<template>
  <div id="app" class="container px-3">

    <header class="my-5">
      <a href=".">
        <h1 class="title m-0">Boston Public Library Digital Collections Search <strong>Beta</strong></h1>  
      </a>

      <a href="https://www.bpl.org/">
        <img :src="require('@/assets/bpl-logo.png')" alt="BPL Logo">
      </a>
    </header>

    <div class="content">
      <p>
        This search tool runs a basic search across all Boston Public Library digital collections stored in the library's statewide Digital Commonwealth repository and in the Internet Archive.
      </p>
      <p>
        This is a prototype of a tool to provide better access to the entirety of our digital collections.
      </p>
      <p>
        <a href="https://forms.office.com/r/FLfVLySbfx" target="_blank">Share your feedback<svg class="external-icon"><use href="#external-link"></use></svg></a>
      </p>
    </div>
    
    <UnionSearch/>
    <svg style="display: none">
      <symbol width="10" height="10" id="external-link" viewBox="0 0 512 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path width="10" height="10" d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/>
      </symbol>
    </svg>
  </div>
</template>

<script>
import UnionSearch from './components/UnionSearch.vue'


export default {
  name: 'App',
  components: {
    UnionSearch
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables.sass";
$primary: #006688;

@import "~bulma/bulma.sass";

#app {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#app h1 {
  font-weight: bold;
}

#app h1 strong {
  font-weight: 300;
}

header img {
  height: 80px;
}

.content {
  max-width: 30rem;
}

.external-icon {
  height: 10px;
  width: 10px;
  margin-left: 6px;
}

</style>
